/**
 * Gallery
 * based on Flickity
 */


window.jsGallery = function () {

    // Elements
    var $galleryElement = $('.js-gallery'),
        galleryStage = '.js-gallery__stage',
        galleryItem = '.js-gallery__item',
        galleryItemCaption = '.js-gallery__item-caption',
        galleryCaptionContainer = '.js-gallery__caption',
        galleryThumbGroup = '.js-gallery__thumbs',
        galleryThumbnail = '.js-gallery__thumb';

    // Hide item captions
    $(galleryItemCaption).hide();

    // Iterate over each gallery
    $galleryElement.each(function (i) {

        var $this = $(this);

        var $gallery = $this.find(galleryStage).flickity({
            prevNextButtons: false,
            draggable: false,
            pageDots: false,
            cellSelector: galleryItem
        });

        // Flickity instance
        var flkty = $gallery.data('flickity');

        // elements
        var $cellButtonGroup = $this.find(galleryThumbGroup);
        var $cellButtons = $cellButtonGroup.find(galleryThumbnail);
        var $captionContainer = $this.find(galleryCaptionContainer);

        // select first cellButton
        $cellButtons.eq(flkty.selectedIndex)
            .addClass('is-selected');

        // update selected cellButtons
        $gallery.on('cellSelect', function () {

            $cellButtons.filter('.is-selected')
                .removeClass('is-selected');

            $cellButtons.eq(flkty.selectedIndex)
                .addClass('is-selected');

        });

        // select cell on button click
        $cellButtonGroup.on('click', galleryThumbnail, function () {
            var index = $(this).parent().index();
            $("video").each(function () {
                this.pause();
            });
            $gallery.flickity('select', index);
        });

        // Add caption function
        function addGalleryItemCaption() {
            var $caption = $this.find('.flickity-slider > .is-selected >' + galleryItemCaption).html();
            if ($caption) {
                $captionContainer.html($caption);
            } else {
                $captionContainer.empty();
            }
        }

        // Add caption on load
        addGalleryItemCaption();

        // Add caption on cellSelect
        $gallery.on('cellSelect', function () {
            addGalleryItemCaption()
        });

    });

};


(function ($) {
    jsGallery();
})(jQuery);
